import { PropsWithChildren } from 'react';
import styles from './WarningPage.module.css';

export type WarningPageProps = PropsWithChildren<{
    message: string;
}>;

function IconWarning() {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <path d="M12 9v4M12 17h.01" />
        </svg>
    );
}

export function WarningPage({ message, children }: WarningPageProps) {
    return (
        <div className={styles.root}>
            <div className={styles.card}>
                <div className={styles.iconWrap}>
                    <IconWarning />
                </div>
                <p className={styles.message}>{message}</p>
                {children}
            </div>
        </div>
    );
}
